import * as React from "react";
const SvgFiRrMagnet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-magnet_svg__a)">
      <path
        fill="#062147"
        d="M21 0h-2c-1.654 0-3 1.346-3 3v8.785c0 2.16-1.583 4.003-3.604 4.196A3.98 3.98 0 0 1 9.31 14.96 4 4 0 0 1 8 12V3c0-1.654-1.346-3-3-3H3C1.346 0 0 1.346 0 3v8.637c0 6.698 5.5 12.365 12.002 12.365 3.165 0 6.143-1.216 8.405-3.437A11.92 11.92 0 0 0 24 12.002V3c0-1.654-1.346-3-3-3M2 3c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v2H2zm20 9.002a9.93 9.93 0 0 1-2.994 7.136c-1.931 1.896-4.466 2.928-7.194 2.862C6.402 21.901 2 17.252 2 11.637V7h4v5a6 6 0 0 0 1.965 4.44 6.04 6.04 0 0 0 4.622 1.532c3.036-.29 5.414-3.007 5.414-6.187V7h4zM22 5h-4V3c0-.551.448-1 1-1h2c.552 0 1 .449 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-magnet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMagnet;
